module.exports = __webpack_public_path__ + "media/components/lesson2/common/statics/displayText-9ad17e308ee96b933054002e5ac8990a.gif";